var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "478.000000pt",
    viewBox: "0 0 512.000000 478.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,478.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3660 4392 l0 -369 -102 -6 c-57 -4 -157 -16 -224 -27 -850 -139 -1473 -656 -1735 -1441 -63 -188 -129 -521 -129 -649 l0 -45 52 60 c28 33 97 105 152 160 477 471 1077 638 1849 514 l137 -22 0 -365 c0 -228 4 -362 10 -360 5 2 333 331 730 731 l720 728 -722 730 c-397 401 -725 729 -730 729 -4 0 -8 -166 -8 -368z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 3749 c-65 -32 -99 -66 -135 -133 l-22 -41 0 -1680 0 -1680 22 -41 c34 -63 66 -97 125 -129 l53 -30 2050 0 2050 0 54 30 c65 36 105 83 131 153 20 51 20 76 18 807 l-3 753 -287 -284 -288 -285 0 -304 0 -305 -1675 0 -1675 0 0 1315 0 1315 343 0 342 1 39 56 c81 117 205 262 330 385 l129 128 -770 0 -770 0 -61 -31z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d9736cb3c1c5305331de7942dc4f8288.svg";
export { ForwardRef as ReactComponent };